export default "__VITE_ASSET__fad49f6d__"